export default {"src":"/_next/static/media/workay-logo.a70ff81a.svg","height":60,"width":60};